import React, { useEffect, useState } from 'react'
import { useNavigate, Outlet, useLocation } from 'react-router'
import {
  Button,
  Card,
  CardBody,
  Col,
  // Container,
  Input,
  Row,
  Spinner,
  Table,
} from 'reactstrap'
import { fetchData } from '../api'
import UserGuide from '../UserGuide'
import { useSearchParams } from 'react-router-dom'
import Overview from './Overview'
import { ExcelDownload } from './IndicatorBreakdown'

const WorldOutlook = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const [searchParams, setSearchParams] = useSearchParams()
  const [countryList, setCountryLust] = useState([])
  const [indicatorList, setIndicatorList] = useState([])
  const [yearList, setYearList] = useState([])
  const disableIndicatorInputs = location.pathname.includes(
    'countries-by-indicator',
  )
  const [loading, setLoading] = useState(false)
  const [form, setForm] = useState({
    type_of_data: "Sub-Saharan Africa Regional Economic Outlook?(AFRREO)",
    // year_from: ''
  });
  const [formattedData, setFormattedData] = useState([])
  //   const [form, setForm] = useState({
  //         // indicator: ['Regional Indicator'],
  //         indicator: ["Real GDP Growth (Annual percent change)"],
  //         country: ["Regional Outlook"],
  //         year_from: "2002",
  //         year_to: "2022",
  //         region: "west africa",
  //         type_of_data: props.type,
  //         new_indicator: [],
  //         // new_indicator: ["GDP based on PPP, share of world (Percent of World)"],
  //       });

  // const indicator = searchParams.get('indicator')
  // const country = searchParams.get('country')
  // const year_from = searchParams.get('year_from')
  // const year_to = searchParams.get('year_to')
  // const region = searchParams.get('region')
  // const type_of_data = searchParams.get('type_of_data')
  // const new_indicator = searchParams.get('new_indicator')

  const getQueryParams = (key, value) => {
    setForm((p) => ({ ...p, [key]: value }))
    // let oldParams = {
    //   indicator,
    //   country,
    //   year_from,
    //   year_to,
    //   region,
    //   type_of_data,
    //   new_indicator,
    // }
    // let params = [
    //   'indicator',
    //   'country',
    //   'year_from',
    //   'year_to',
    //   'region',
    //   'type_of_data',
    //   'new_indicator',
    // ]
    // const newParams = {}
    // params.forEach((i) => {
    //   if (i !== key) {
    //     newParams[i] = oldParams[i]
    //   } else {
    //     newParams[key] = value
    //   }
    // })
    // return newParams
  }

  const handleChange = ({ target: { name, value } }) =>
    getQueryParams(name, value)

  const stageOne = true
  const display = true

  useEffect(() => {
    fetchData({ query_type: 'get_countries' })
      .then((d) => {
        if (d && d.results && d.results.length) {
          setCountryLust([
            'Regional Outlook',
            ...d.results.map((a) => a.country),
          ])
        }
      })
      .catch((e) => {
        console.log(e)
      })
  }, [])

  useEffect(() => {
    fetchData({ query_type: 'get_indicators', type_of_data: form.type_of_data })
      .then((d) => {
        // console.log(d.results)
        if (d && d.results && d.results.length) {
          setIndicatorList([
            // 'Regional Indicator',
            ...d.results.map((a) => a.indicator),
          ])
          //   setForm((p) => ({ ...p, new_indicator: [d.results[0].indicator] }));4
          setForm((p) => ({
            ...p,
            year_from: "2004",
            year_to: "2022",
            country: "Regional Outlook",
            region: "wSub-Saharan Africa",
            type_of_data:
              "Sub-Saharan Africa Regional Economic Outlook?(AFRREO)",
            indicator: d.results[0].indicator,
            new_indicator: d.results[0].indicator,
          }));
          //   setSearchParams(getQueryParams('indicator', d.results[0].indicator));
          //   setSearchParams(getQueryParams('new_indicator', d.results[0].indicator));
        }
      })
      .catch((e) => {
        console.log(e)
      })
  }, [form.type_of_data])

  useEffect(() => {
    fetchData({
      query_type: 'get_years',
    })
      .then((d) => {
        if (d && d.results && d.results.length) {
          // console.log(d.results[d.results.length - 1].year, 'from')
          // console.log(d.results[0].year, 'to')
          setYearList(d.results.map((a) => a.year))
        }
      })
      .catch((e) => {
        console.log(e)
      })
  }, [])

  //   useEffect(() => {}, [])

  return (
    <>
      <div className="d-flex flex-direction-row justify-content-between align-items-center">
        <div>
          <Button
            size="sm"
            onClick={() => navigate(-1)}
            color="warning"
            className=""
          >
            Go back
          </Button>
          <Button
            className="m-2"
            color={display ? 'primary' : 'secondary'}
            onClick={() => navigate('/annual-change')}
          >
            Annual Percentage Change
          </Button>
        </div>
        {/* <Button
          // onClick={() => getRegionalAverage()}
        //   onClick={() => setDisplay(false)}
        //   color={!display ? "primary" : "secondary"}
          className="m-2"
        >
          Regional Average
        </Button>
        <Button
          className="m-2"
        //   color={display ? "primary" : "secondary"}
        //   onClick={() => setDisplay(true)}
        >
          Weighted Average
        </Button> */}

        <ExcelDownload
          raw={formattedData}
          fileName={`World economic outlook regional Average per indicator (${form.year_from} - ${form.year_to})`}
        />
      </div>
      rtdfyguhikl;
      {loading && <LoadingComponent />}
      <Row>
        <Col md={9}>
          {/* {JSON.stringify(form)} */}
          {disableIndicatorInputs ? null : (
            <CardBody>
              <Row>
                <Col md={6}>
                  <>
                    <label className="text-white">Select Indicator</label>
                    <Input
                      type="select"
                      value={form.indicator}
                      name="indicator"
                      onChange={({ target: { value } }) => {
                        getQueryParams('indicator', value)
                        // setSearchParams({indicator: [value]})
                      }}
                    >
                      <option>--select--</option>
                      {indicatorList.map((indicator, id) => (
                        <option key={id} value={indicator}>
                          {indicator}
                        </option>
                      ))}
                    </Input>
                  </>
                </Col>
                <Col md={6}>
                  <>
                    <label className="text-white">Select Country</label>
                    <Input
                      type="select"
                      value={form.country}
                      name="country"
                      onChange={handleChange}
                    >
                      <option>--select--</option>
                      {countryList.map((country, id) => (
                        <option key={id} value={country}>
                          {country}
                        </option>
                      ))}
                    </Input>
                  </>
                </Col>
              </Row>
            </CardBody>
          )}
          {/* {JSON.stringify(isWorldOutlook)} */}
          <div>
            {/* <Outlet /> */}
            <Overview
              indicator={form.indicator}
              country={form.country}
              year_from={form.year_from}
              year_to={form.year_to}
              region={form.region}
              type_of_data={form.type_of_data}
              setFormattedData={setFormattedData}
            />
          </div>
        </Col>
        <Col md={3}>
          {/* <small>{JSON.stringify(stageTwo && isWorldOutlook)}</small> */}
          <label className="text-white">Date range</label>
          <Row className="mb-3">
            <Col md={6} className="m-0 pe-1">
              <Input
                type="select"
                value={form.year_from}
                name="year_from"
                onChange={handleChange}
              >
                <option>--select--</option>
                {yearList.map((indicator, id) => (
                  <option key={id} value={indicator}>
                    {indicator}
                  </option>
                ))}
              </Input>
            </Col>
            <Col md={6} className="m-0 ps-1">
              <Input
                type="select"
                value={form.year_to}
                name="year_to"
                onChange={handleChange}
              >
                {' '}
                <option>--select--</option>
                {yearList.map((indicator, id) => (
                  <option key={id} value={indicator}>
                    {indicator}
                  </option>
                ))}
              </Input>
            </Col>
          </Row>
          <UserGuide stage={1} />
          {/* <SideBar
            form={indicatorByCountry}
            setForm={setForm}
            yearList={yearList}
            handleChange={handleChange}
            rawData={data}
            stageOne={stageOne}
            newArr={newArr}
            setStage={setStage}
            stage={stage}
          /> */}
        </Col>
      </Row>
    </>
  )
}

export function LoadingComponent() {
  return (
    <div>
      <Spinner size={'sm'} /> Please wait...
    </div>
  )
}

export default WorldOutlook
